import React, { FC, useCallback, useState } from 'react'
import cn from 'classnames'
import { useStore } from 'store'
import { observer } from 'mobx-react'
import { Modal } from 'components/Modal'
import { ReactCodeInput } from 'components/ReactCodeInput'

import styles from './styles.module.scss'
import Button from '@mui/material/Button'
import { toast } from 'react-toastify'

interface IProps {
  open: boolean,
  onClose?: () => void,
  email: string,
  phoneNumber: string
  onConfirmed: () => void,
  timer?: number
  resetTimer?: () => void
}

export const CodeModal: FC<IProps> = (
  {
    open,
    onClose,
    timer = 0,
    resetTimer,
    email,
    phoneNumber,
    onConfirmed
  }) => {
  const { reserveVRStore, loadingStore } = useStore()
  const [code, setCode] = useState('')

  const onChangeCode = (value: string) => {
    setCode(value)
  }

  const handleResendCode = async () => {
    try {
      loadingStore.setLoading(true)
      await reserveVRStore.confirmEmailVRSpot(email, '+' + phoneNumber)
      resetTimer && resetTimer()
      toast.success('Verification code has been resent')
    } catch (e) {
      console.log('ResendCode', e)
      return toast.error('Error while resending verification code')
    } finally {
      loadingStore.setLoading(false)
    }
  }

  const confirmCodeVRSpot = async () => {
    try {
      loadingStore.setLoading(true)
      await reserveVRStore.confirmEmailCodeVRSpot(email, code)
      onConfirmed()
      onClose && onClose()
      toast.success('Verification code has been confirmed')
    } catch (e) {
      console.log('ResendCode', e)
      return toast.error('You have entered wrong verification code')
    } finally {
      loadingStore.setLoading(false)
    }
  }

  return (
    <Modal open={open}
           onClose={onClose}
           closeButton
           disableOutsideClick
           scroll={'paper'}
           buttonTitle={'Confirm'}
           onClickButton={confirmCodeVRSpot}
           disabledButton={code.length < 6}
           buttonSX={{ maxWidth: '400px' }}
           title={'Enter the confirmation code'}
           subTitle={<>We sent you a text message with your 6-digit code to this email:<br/>{email}</>}
    >
      <div className={styles.codeModalContainer}>
        <ReactCodeInput onChange={onChangeCode}/>

        <div className={styles.resendCode}>
          <Button
            onClick={handleResendCode}
            variant="text"
            size="small"
            color="primary"
            disabled={timer > 0}
          >
            {timer > 0 ? `Resend Code in ${timer}` : 'Resend Code'}
          </Button>
        </div>
      </div>
    </Modal>
  )
}
